import { useSelector } from 'react-redux';
import { getIsMd } from 'redux/selectors';
import moment from 'moment';
import { DatePicker } from '@mui/x-date-pickers';
import { TextFieldRow } from 'components';

const DatePickerRow = ({
	label,
	value,
	name,
	onChange,
	maxDate,
	maxDateMessage,
	minDate,
	minDateMessage,
	disableFuture = true,
	disabled,
}) => {
	const isMd = useSelector(getIsMd);

	const minMaxProps = {};

	if (maxDate) {
		minMaxProps.maxDate = maxDate;
		minMaxProps.maxDateMessage = maxDateMessage || '';
	} else {
		delete minMaxProps.maxDate;
		delete minMaxProps.maxDateMessage;
	}

	if (minDate) {
		minMaxProps.minDate = minDate;
		minMaxProps.minDateMessage = minDateMessage || '';
	} else {
		delete minMaxProps.minDate;
		delete minMaxProps.minDateMessage;
	}

	const dateLabel = () => {
		if (label) {
			if (isMd) {
				return label;
			} else {
				return null;
			}
		} else {
			return 'No Date Selected';
		}
	};

	const dateValue = moment(value);

	return (
		<TextFieldRow required={true} label={label}>
			<DatePicker
				label={dateLabel()}
				value={dateValue}
				id={`date-picker-inline-${name}`}
				disableFuture={disableFuture}
				name={name}
				onChange={onChange}
				disabled={disabled}
				slotProps={{
					inputAdorment: { position: 'start' },
					textField: { InputProps: { sx: { borderRadius: '12px' } } },
				}}
				{...minMaxProps}
			/>
		</TextFieldRow>
	);
};

export default DatePickerRow;
